import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { DeletePaymentAccountsRequestModel, DeletePaymentAccountsResponseModel } from "@/features/accounts/payment/scraping/services/delete-accounts-model";

export class DeletePaymentAccountsApi {
  /**
   * MoneyLook 口座削除API
   */
  public deletePaymentAccounts = async (
    param: DeletePaymentAccountsRequestModel
  ): Promise<DeletePaymentAccountsResponseModel> => {
    const path = `/api/paymentaccounts/payments`;
    const res = await ApiClient.instance.delete<DeletePaymentAccountsResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
